import axios from "axios";
import GetConfigWhiteLabel from '../services/GetWhiteLabel';
// import JSON from "../config-whitelabel.json";

class Api
{
    api = null;

    async init()
    {
        if( !this.api )
        {
            let configWhitelabel = await GetConfigWhiteLabel();
            if( configWhitelabel )
            {
                // api.defaults.baseURL = configWhitelabel.urlApi;
                this.api = axios.create({
                    baseURL: configWhitelabel.urlApi,    
                });
            }
        }
        // return api;
    }

    async get( url, params )
    {
        let resp = [];
        await this.init();

        if( this.api )
        {
            resp = await this.api.get( url, params );
        }
        return resp;
    }

    async post( url, params, options )
    {
        let resp = [];
        await this.init();

        if( this.api )
        {
            resp = await this.api.post( url, params, options );
        }
        return resp;
    }
}

/*
let BaseURLWB = '';
// let ApiCodeWB = '';
const origin = window.location.pathname.replace(/(^\w+:|^)\/\//, "");
const pathname = origin.replace('/', '');
JSON.map((response) => {
    if(response.identify === pathname){
        BaseURLWB = response.urlApi;
        // ApiCodeWB = response.apiCode;
    }
})
    const api = axios.create({
        baseURL: BaseURLWB,    
    });
*/

const api = new Api();
export default api;
